
import { onMounted, ref } from 'vue';
import Button from 'primevue/button';
import Password from 'primevue/password';
import IftaLabel from 'primevue/iftalabel';
import Message from 'primevue/message';
import PopupMainNavbar from '../components/navbar/PopupMainNavbar.vue';
import PopupAffiliateNavbar from '../components/navbar/PopupAffiliateNavbar.vue';
import { useAuthStore } from '../stores/auth';
import { useToast } from 'primevue/usetoast';
import { external } from '../apis/external';

export default {
	name: 'ChangePassword',
	components: {
		IftaLabel,
		Password,
		Button,
		Message,
	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate();

		const toast = useToast();

		onMounted(() => {
			auth.hydrate()
		})

		const form = ref({
			oldPassword: {
				value: '',
				invalid: false,
				msgErr: '',
			},
			newPassword:  {
				value: '',
				invalid: false,
				msgErr: '',
			},
			confirmPassword:  {
				value: '',
				invalid: false,
				msgErr: '',
			},
			btn: {
				loading: false,
				disabled: false,
			}
		});

		const validate = () => {
			if (!form.value.oldPassword.value || !form.value.newPassword.value || !form.value.confirmPassword.value) {
				const msg = 'กรุณากรอกข้อมูลให้ครบถ้วน';
				form.value.oldPassword.msgErr = msg;
				form.value.newPassword.msgErr = msg;
				form.value.confirmPassword.msgErr = msg;

				form.value.oldPassword.invalid = true;
				form.value.newPassword.invalid = true;
				form.value.confirmPassword.invalid = true;
				return false;
			}

			if (form.value.newPassword.value !== form.value.confirmPassword.value) {
				const msg = 'รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน';
				form.value.oldPassword.msgErr = '';
				form.value.newPassword.msgErr = msg;
				form.value.confirmPassword.msgErr = msg;

				form.value.oldPassword.invalid = false;
				form.value.newPassword.invalid = true;
				form.value.confirmPassword.invalid = true;
				return false;
			}

			return true;
		};

		const handleSubmit = async () => {
			form.value.btn.loading = true;

			form.value.oldPassword.msgErr = '';
			form.value.newPassword.msgErr = '';
			form.value.confirmPassword.msgErr = '';

			form.value.oldPassword.invalid = false;
			form.value.newPassword.invalid = false;
			form.value.confirmPassword.invalid = false;

			if (!validate()) return;

			try {
				const payload = {
					oldPassword: form.value.oldPassword.value,
					password: form.value.newPassword.value,
				}

				const resp = await external.updatePass(payload)

				if (resp.code !== '0') throw new Error(resp.message)

				toast.add({ severity: 'success', summary: resp.message, detail: 'เปลี่ยนรหัสผ่านใหม่สำเร็จ', life: 3000 });
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				form.value.btn.loading = false;
			}
		};

		const checkPassword = () => {
			const oldPassword = form.value.oldPassword.value.trim();
			const allowedChars = /^[A-Za-z0-9@#$%&*!_.?\-]+$/;
			if (!allowedChars.test(oldPassword)) {
				form.value.oldPassword.invalid = true;
				form.value.oldPassword.msgErr = 'รหัสผ่านใช้ได้เฉพาะ A-Z, a-z, 0-9 และ @#$%&*!_.?-';
				return;
			}

			if (oldPassword.length < 8) {
				form.value.oldPassword.invalid = true;
				form.value.oldPassword.msgErr = 'รหัสผ่านต้องมีอย่างน้อย 8 ตัวอักษร';
				return;
			}

			form.value.oldPassword.invalid = false;
			form.value.oldPassword.msgErr = '';
		};

		return {
			form,
			checkPassword,
			handleSubmit,
		};
	},
};
